import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tr from './tr.json';
import en from './en.json';

const saved = localStorage.getItem('mymaintenances-lang') || 'tr';

i18n.use(initReactI18next).init({
  resources: {
    tr: { translation: tr },
    en: { translation: en },
  },
  lng: saved,
  fallbackLng: 'tr',
  interpolation: { escapeValue: false },
});

export default i18n;
